// extracted by mini-css-extract-plugin
export default {"actions":"tr_actions__pt45A","trigger":"tr_trigger__+eSdG","background":"tr_background__E9w2+","menu":"tr_menu__j-1mA"};